import Vue from 'vue'
import Router from 'vue-router'
import jh from '@/views/jh'
import Report from '@/views/report'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'jh',
      component: jh
    },
    {
      path: '/report/:id',
      name: 'ViewReport',
      component: Report
    }
  ],
  
  // 平滑滚动
  scrollBehavior(to, from, savedPosition) {
     if (to.hash) {
      return {
        selector: to.hash
      }
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
